import React from 'react';
import "./Advantages.css";

const Advantages = () => {
  return (
    <div className='advantages section-p' id="advantages">
        <div className='container'>
            <div className='advantages-content'>
                <div className='section-title'>
                    <h3 className='text-brown'>Ventajas para el <span className='text-dark'>Propietario</span></h3>
                </div>
                <ul className='advantages-list'>
                    <li className='advantages-item'>
                        <strong>Cero riesgo de impago:</strong> Nosotros somos quienes pagamos siempre, garantizando tu renta mensual sin excepciones.
                    </li>
                    <li className='advantages-item'>
                        <strong>Filtro exhaustivo de inquilinos:</strong> Seleccionamos únicamente perfiles premium y confiables para asegurar la tranquilidad de tu propiedad.
                    </li>
                    <li className='advantages-item'>
                        <strong>Mantenimiento y limpieza periódica:</strong> El inmueble estará mejor que nunca, con cuidados profesionales constantes.
                    </li>
                    <li className='advantages-item'>
                        <strong>Gestión de suministros y averías incluida:</strong> Nos ocupamos de todo, desde facturas hasta reparaciones inesperadas.
                    </li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default Advantages